const extractLookupAddressParts = (lookupAddress) => [
    lookupAddress.line_1,
    lookupAddress.line_2,
    lookupAddress.line_3,
    lookupAddress.post_town,
    lookupAddress.postcode,
];
const extractAddressParts = (address) => [
    address.address_1,
    address.address_2,
    address.address_3,
    address.town_city,
    address.post_code,
];
export const lookupAddressToSingleLine = (lookupAddress) => extractLookupAddressParts(lookupAddress)
    .filter((part) => part != null && part !== '')
    .join(', ');
export const addressToSingleLine = (address) => extractAddressParts(address)
    .filter((part) => part != null && part !== '')
    .join(', ');
export const lookupAddressToAddress = ({ lookupAddress, existingAddress, addressableId, addressableType, }) => ({
    id: existingAddress?.id,
    address_1: lookupAddress.line_1,
    address_2: lookupAddress.line_2,
    address_3: lookupAddress.line_3,
    town_city: lookupAddress.post_town,
    post_code: lookupAddress.postcode,
    lat: lookupAddress.latitude,
    lng: lookupAddress.longitude,
    uprn: lookupAddress.uprn,
    addressable_id: addressableId,
    addressable_type: addressableType,
    multiline: extractLookupAddressParts(lookupAddress),
});
export const manualAddressToAddress = (manualAddress) => ({
    address_1: manualAddress.address_1 || '',
    address_2: manualAddress.address_2 ?? null,
    address_3: manualAddress.county ?? null,
    town_city: manualAddress.city || '',
    post_code: manualAddress.postcode || '',
    lat: null,
    lng: null,
});
